var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.61 10.042-.18.412a.368.368 0 0 1-.678 0l-.18-.412a3.17 3.17 0 0 0-1.614-1.636l-.552-.247a.386.386 0 0 1 0-.7l.522-.232a3.18 3.18 0 0 0 1.637-1.692l.184-.444a.368.368 0 0 1 .685 0l.184.443a3.18 3.18 0 0 0 1.636 1.693l.522.232a.385.385 0 0 1 0 .7l-.552.246c-.724.325-1.3.909-1.614 1.637m-7.792-3.73h2.91v1.455h-2.91a4.364 4.364 0 0 0-4.363 4.364c0 2.625 1.79 4.339 5.818 6.167v-1.803h1.454a4.363 4.363 0 0 0 4.364-4.364h1.455a5.82 5.82 0 0 1-5.818 5.818v2.546C9.09 19.04 4 16.858 4 12.13a5.82 5.82 0 0 1 5.818-5.818"
  })));
};
export default SvgChat;